export default "__VITE_ASSET__b3ecff9c__"